import { Card } from '../../../../../components/card/card';
import { Loader } from '../../../../../components/loader/loader';
import { Page } from '../../../../../components/page/page';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { RolesDictionaryAdmins } from './roles-dictionary-admins/roles-dictionary-admins';
import { RolesDictionaryCreateModal } from './roles-dictionary-create-modal/roles-dictionary-create-modal';
import { RolesDictionaryGrouped } from './roles-dictionary-grouped/roles-dictionary-grouped';
import { RolesDictionaryUnattachModal } from './roles-dictionary-unattach-modal/roles-dictionary-unattach-modal';
import s from './roles-dictionary.module.css';
import { useRolesDictionary } from './use-roles-dictionary';

export const RolesDictionary = () => {
  const {
    isLoading,
    t,
    roles = [],
    deleteRole,
    createRoleModal,
    unattachRoleModal,
    groupedByRoleAdmins,
    isAdminsLoading,
  } = useRolesDictionary();

  return (
    <Page className={s.page}>
      <h2>{t('Справочник ролей')}</h2>

      {(isLoading || isAdminsLoading) && <Loader />}

      <div className={s.content}>
        <Card title={t('Локальные роли')}>
          <ul className={s.list}>
            {roles.map((item) => (
              <RolesDictionaryGrouped key={item.id} role={item} />
            ))}
          </ul>
        </Card>

        <Card title={`🔒 ` + t('Системные роли')}>
          <ul className={s.list}>
            {Object.entries(groupedByRoleAdmins || {}).map(([key, value]) => (
              <RolesDictionaryAdmins key={key} role={key} admins={value} />
            ))}
          </ul>
        </Card>
      </div>

      <HasAccess service="staff" permissions={['write']}>
        <DeleteModal prefix="role" onSubmit={deleteRole} />

        {createRoleModal.isOpen && (
          <RolesDictionaryCreateModal
            onClose={() => createRoleModal.handleCloseModal(['roleId'])}
          />
        )}

        {unattachRoleModal.isOpen && (
          <RolesDictionaryUnattachModal
            onClose={() => unattachRoleModal.handleCloseModal(['employeeId', 'roleId'])}
          />
        )}
      </HasAccess>
    </Page>
  );
};
